import { SendELinxRequest, SendELinxResponse } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

// Direct-Pattern port of the portal's legacy tuple hook usePostSendPaylink.
export default function useSendPaylink() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);

  async function sendPaylink(params: SendELinxRequest): Promise<SendELinxResponse> {
    try {
      setFetching(true);

      const res = await api.postSendPaylink(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, sendPaylink };
}
